const Blockly = require('blockly');
const dataAccessMethods = require('../../../../dataAccessMethods');
const setupAddCodeProperties = require('../../../../helpers/addCodeProperties');
const convertToBoolean = require('../../../../helpers/convertToBoolean');
const { addSecurityModifiersToBlock, addSecurityModifiersToCode } = require('../../../../helpers/blockInitMethods');
const TOOLTIP = 'Filter a given control\'s contents based on the selection made by a user in a different control on the same form.';

function addBlockSpecificFields(color, blocklyBlock, mdcBlock, line1OfInputs) {
    let workspace = blocklyBlock.workspace;
    let blockId = blocklyBlock.id;

    blocklyBlock.setTooltip(TOOLTIP);
    //set inputs to be arranged vertically.
    //Meaning each (dummy)input starts a new line
    blocklyBlock.setInputsInline(true);
    line1OfInputs
        .appendField('|   Parent Namespace:')
        .appendField(new Blockly.FieldDropdown(dataAccessMethods.getNamespaces), 'namespace')
        .appendField('  Parent Relation:')
        .appendField(
            new Blockly.FieldDropdown(() => dataAccessMethods.getRelations(workspace, blockId)),
            'relation'
        )
        .appendField('  ') // space it out
        .appendField(new Blockly.FieldCheckbox(false), 'disableBeforeParentSelection')
        .appendField(' Disable until parent is selected');

    addSecurityModifiersToBlock(blocklyBlock);
}

function convertCustomFieldsToCode(code, blocklyBlock) {
    const addCodeProperties = setupAddCodeProperties(code, blocklyBlock);
    addCodeProperties(['namespace', 'relation', { key: 'disableBeforeParentSelection', handler: convertToBoolean }]);
    addSecurityModifiersToCode(code, blocklyBlock);
    return code;
}



module.exports = { addBlockSpecificFields, convertCustomFieldsToCode };